import { LoadProjectList } from '@/javascript/domain/usecases'
import { AccessDeniedError, UnexpectedError } from '@/javascript/domain/errors'
import { HttpClient, HttpStatusCode } from '../protocols/http'

export class RemoteLoadProjectList implements LoadProjectList {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<RemoteLoadProjectList.Response>
  ) {}

  async load(searchText?: string): Promise<LoadProjectList.Model[]> {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'get',
      params: {
        q: searchText
      }
    })
    const response = httpResponse.body
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return formatResponse(response)
      case HttpStatusCode.noContent: return []
      case HttpStatusCode.forbidden: throw new AccessDeniedError()
      default: throw new UnexpectedError()
    }
  }
}

export namespace RemoteLoadProjectList {
  export type Project = {
    id: number
    name: string
    created_at: string
    updated_at: string
  }
  export type Response = {
    results: Project[]
  }
}

const formatResponse = (projects: RemoteLoadProjectList.Response): LoadProjectList.Model[] => {
  return projects?.results.map(project => ({
    id: project.id,
    name: project.name,
    createdAt: project.created_at,
    updatedAt: project.updated_at,
  })) || []
}
